import { ONE_MB } from '@/utils/formatBytes';

export const MAX_DOCUMENT_SIZE_MB = ONE_MB * 200;

export const SAFE_TRANSFER_MAX_FILE_SIZE_BYTES = ONE_MB * 100;

export const API_URL_BASE = '/api/v1/';

export const HOME_ROUTE = '/dashboard';

export const PAYMENT_DETAILS_ROUTE =
  '/account/subscription/checkout?mode=payment-details';

export const UPGRADE_ROUTE = '/account/subscription/checkout?mode=subscribe';

export const ENTERPRISE_CONTACT_URL =
  'https://calendar.app.google/HJXEdTtibf7dSLEBA';

export const DOCS_MCP_URL = `${API_URL_BASE}docs/mcp`;

export const MAX_SIGNERS_PER_SIGNING = 15;
export const MAX_SIGNINGS_PER_DAY = 10;

export const LANGUAGES = {
  en: { flag: 'gb', name: 'English', short: 'en' },
  cs: { flag: 'cz', name: 'Čeština', short: 'cs' },
  de: { flag: 'de', name: 'Deutsch', short: 'de' },
  es: { flag: 'es', name: 'Español', short: 'es' },
  fr: { flag: 'fr', name: 'Français', short: 'fr' },
  it: { flag: 'it', name: 'Italiano', short: 'it' },
  sk: { flag: 'sk', name: 'Slovenčina', short: 'sk' },
  'zh-Hant-TW': { flag: 'zh', name: 'Traditional Chinese', short: 'zh' },
};

export const LANGUAGE_ALIAS: Record<string, string> = {
  ZH: 'zh-Hant-TW',
};

const REVERSE_LANGUAGE_ALIAS: Record<string, string> = Object.fromEntries(
  Object.entries(LANGUAGE_ALIAS).map(([k, v]) => [v, k])
);

export const resolveLang = (lng?: string | null) =>
  (lng && LANGUAGE_ALIAS[lng]) || lng || 'en';

export const displayLang = (lng?: string | null) =>
  (lng && REVERSE_LANGUAGE_ALIAS[lng]) || lng || 'EN';

export const POLL_INTERVALL_STARTING = 1_000 * 2; // Two seconds
export const POLL_INTERVALL_AUDIT_TRAIL = 2_000 * 60; // Two minute
export const POLL_INTERVALL_SIGNERS = 1_000 * 60; // One minute

export const API_CACHE_TTL = 1000 * 60 * 5; // 5 minute TTL

export const PHONE_INPUT_DEBOUNCE_TIME = 400;

export const DEFAULT_ANIMATION_DURATION = 0.25; // in seconds!
export const MODAL_ANIMATION_DURATION = 0.2; // in seconds!

export const PLACEHOLDER_SIZE = {
  width: 150,
  height: 60,
};
